export default {
  camera: {
    zDist: 20,
    angularSpeed: 0.1,
  },
  bunny: {
    speed: 30,
    angularSpeed: 10,
  },
  exit: {
    dist: 30 + Math.random() * 60
  }
}